export enum ESitesPerm {
    EVENTS_VIEW = 'sites_view',
    EVENTS_EDIT = 'sites_edit',
    EVENTS_DELETE = 'sites_delete'
}
